import { Component, EventEmitter, Input, Output } from "@angular/core";
import { NgClass } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SvgIconComponent } from "../../../svg-icon/svg-icon.component";
import { Charge } from "../../../../models/charge.interface";
import { StaticTableComponent } from "../../../static-table/static-table.component";
import { TableMeta } from "../../../../models/table-meta.interface";
import ChargeObjectMeta from "./config/change-object-meta.json";
import { AutocompleteDropdownComponent } from "../../../autocomplete-dropdown/autocomplete-dropdown.component";
import { FinanceApiService } from "../../../../services/finance-a-p-iervice.service";
import { LoadingService } from "../../../../services/loading.service";

@Component({
  selector: "app-add-charges",
  standalone: true,
  imports: [
    ReactiveFormsModule,
    SvgIconComponent,
    FormsModule,
    NgClass,
    StaticTableComponent,
    AutocompleteDropdownComponent
  ],
  templateUrl: "./add-charges.component.html",
  styleUrl: "./add-charges.component.scss"
})
export class AddChargesComponent {
  preSelectedRowsIds: Set<string> = new Set<string>;
  tableMeta!: TableMeta;
  chargesAlreadyInChargeGroup: any[] = [];
  selectedCharge!: Charge;
  searchAndAddText: any = "";
  disableAddBtn: boolean = true;
  selectedItems: any[] = []

  @Input() selectedChargeGroupId: string = ""
  @Output() selectedChargesEmitter = new EventEmitter<any>();

  constructor(private financeApiService: FinanceApiService,private loadingService: LoadingService) {
  }

  ngOnInit(){
    this.tableMeta = ChargeObjectMeta;
    this.getTableList()
  }

  getTableList(){
    this.loadingService.show('inline')
    this.financeApiService.getChargeGroupById(this.selectedChargeGroupId).subscribe({
      next: (res: any) => {
        const chargesIds = res.data.charges?.map((charge: Charge) =>  charge.id) ?? []
        this.preSelectedRowsIds = new Set(chargesIds);
        this.chargesAlreadyInChargeGroup = res.data.charges ?? [];
        this.loadingService.hide(800)
      },
      error: err => {
        this.loadingService.hide()
        console.error(err);
      }
    })
  }

  handleSuggestionSelected(selectedCharge: any) {
    this.selectedCharge = selectedCharge;
    this.disableAddBtn = false;
  }

  addNewChargesToChargeGroup() {
    this.chargesAlreadyInChargeGroup.push(this.selectedCharge)
    this.preSelectedRowsIds.add(this.selectedCharge.id);
    this.searchAndAddText = "";
    this.disableAddBtn = true;
    this.selectedChargesEmitter.emit(Array.from(this.preSelectedRowsIds));
  }

  handleDataDeletion(data: any) {
    this.preSelectedRowsIds.delete(data.id);
    this.selectedChargesEmitter.emit(Array.from(this.preSelectedRowsIds));
  }

  handleBulkDelete() {
    this.chargesAlreadyInChargeGroup = this.chargesAlreadyInChargeGroup.filter((record: Charge) => !this.selectedItems.includes(record))

    this.selectedItems.forEach((record: Charge) => {
      this.preSelectedRowsIds.delete(record.id);
    })

    this.selectedItems = []

    this.selectedChargesEmitter.emit(Array.from(this.preSelectedRowsIds));
  }

  protected readonly Array = Array;
}
